var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ai-name"},[_c('span',{staticClass:"ai-name-prefix"},[_vm._v("Ai")]),_vm._v("助理")])}]

export { render, staticRenderFns }